<template>
    <div>
        <q-expansion-item expand-separator default-opened v-model="computedExpanded" header-class="bg-white text-left"
            class="bg-white shadow-3">
            <template v-slot:header>
                <q-item-section side>
                    <q-icon name="search" />
                </q-item-section>
                <q-item-section>
                    <q-item-label class="text-body1">Filtro</q-item-label>
                </q-item-section>
            </template>
            <div class="q-ma-sm">
                <slot name="filtros"></slot>
                <div class="row q-gutter-x-sm">
                    <q-btn-group class="c-btn-group q-ma-sm" outline>
                        <q-btn push color="primary" class="q-ml-sm" @click="aplicarFiltro"
                        @keyup.enter="aplicarFiltro" :disable="desabilitaBtnBuscar">Buscar</q-btn>
                        <q-btn v-if="mostraBtnLimpar" push @click="limparFiltro" :disable="desabilitaBtnLimpar">Limpar</q-btn>
                    </q-btn-group>
                    <slot name="buttons"></slot>
                </div>
            </div>
        </q-expansion-item>
    </div>
</template>
<script>
// import { ref } from 'vue';

export default {
    name: 'QLinsFilterBox',

    emits: ['update','limparFiltro','aplicarFiltro'],

    props: {
        expanded: {
            type: Boolean,
            default: true
        },

        aplicarBusca:{
            type: Function,
            default: () => {}
        },

        limpar: {
            type: Function,
            default: () => {}
        },
        desabilitaBtnBuscar:{
            type: Boolean,
            default: false
        },
        desabilitaBtnLimpar: {
            type: Boolean,
            default: false
        },

        mostraBtnLimpar: {
            type: Boolean,
            default: true
        },
    },
    computed: {
        computedExpanded: {
            get() {
                return this.expanded
            },
            set(value) {
                this.$emit('update', value)
            }
        }
    },
    methods: {
        aplicarFiltro(){
            this.aplicarBusca()
            this.$emit('aplicarFiltro')
        },
        limparFiltro(){
            this.limpar()
            this.$emit('limparFiltro')
        },
        $_limparFiltros(){
            
        },
        $_aplicarFiltros(){}
    }
}
</script>
